export const FIGMA_COLORS = {
  primaryLight: "#65558F",
  primaryLightHighContrast: "#27174E",
  primaryLightMediumContrast: "#493971",
  primaryDark: "#D0BCFE",
  primaryDarkHighContrast: "#FFF9FF",
  primaryDarkMediumContrast: "#D3C1FF",
  primaryMonochromeLT: "#000000",
  primaryMonochromeDT: "#FFFFFF",
  primaryPinkLT: "#8A4B68",
  primaryPinkDT: "#FEB0D1",
  primaryRoseLT: "#8F4A56",
  primaryRoseDT: "#FFB2BD",
  primaryRedLT: "#914B43",
  primaryRedDT: "#FFA79B",
  primaryOrangeLT: "#8D4F28",
  primaryOrangeDT: "#FFB68C",
  primaryYellowLT: "#795A0C",
  primaryYellowDT: "#E9C16C",
  primaryChartreuseLT: "#5C641E",
  primaryChartreuseDT: "#C3CD7C",
  primaryGreenLT: "#376A3E",
  primaryGreenDT: "#9CD49F",
  primaryTealLT: "#006B60",
  primaryTealDT: "#82D5C7",
  primaryCyanLT: "#01687D",
  primaryCyanDT: "#86D1EA",
  primaryBlueLT: "#485E92",
  primaryBlueDT: "#B0C6FF",
  primaryIndigoLT: "#5B5992",
  primaryIndigoDT: "#C5C0FF",
  primaryPurpleLT: "#6B548D",
  primaryPurpleDT: "#D6BBFB",
  onPrimaryLight: "#FFFFFF",
  onPrimaryLightHighContrast: "#FFFFFF",
  onPrimaryLightMediumContrast: "#FFFFFF",
  onPrimaryDark: "#381E72",
  onPrimaryDarkHighContrast: "#000000",
  onPrimaryDarkMediumContrast: "#1B0942",
  onPrimaryMonochromeLT: "#E2E2E2",
  onPrimaryMonochromeDT: "#1A1C1C",
  onPrimaryPinkLT: "#FFFFFF",
  onPrimaryPinkDT: "#531D39",
  onPrimaryRoseLT: "#FFFFFF",
  onPrimaryRoseDT: "#561D29",
  onPrimaryRedLT: "#FFFFFF",
  onPrimaryRedDT: "#561E18",
  onPrimaryOrangeLT: "#FFFFFF",
  onPrimaryOrangeDT: "#532200",
  onPrimaryYellowLT: "#FFFFFF",
  onPrimaryYellowDT: "#3F2E00",
  onPrimaryChartreuseLT: "#FFFFFF",
  onPrimaryChartreuseDT: "#2D3400",
  onPrimaryGreenLT: "#FFFFFF",
  onPrimaryGreenDT: "#003913",
  onPrimaryTealLT: "#FFFFFF",
  onPrimaryTealDT: "#003731",
  onPrimaryCyanLT: "#FFFFFF",
  onPrimaryCyanDT: "#003642",
  onPrimaryBlueLT: "#FFFFFF",
  onPrimaryBlueDT: "#152E60",
  onPrimaryIndigoLT: "#FFFFFF",
  onPrimaryIndigoDT: "#2D2960",
  onPrimaryPurpleLT: "#FFFFFF",
  onPrimaryPurpleDT: "#3B255A",
  primaryContainerLight: "#EADDFF",
  primaryContainerLightHighContrast: "#493971",
  primaryContainerLightMediumContrast: "#7B6BA7",
  primaryContainerDark: "#4F378B",
  primaryContainerDarkHighContrast: "#D3C1FF",
  primaryContainerDarkMediumContrast: "#9887C5",
  primaryContainerMonochromeLT: "#3B3B3B",
  primaryContainerMonochromeDT: "#D4D4D4",
  primaryContainerPinkLT: "#FEB0D1",
  primaryContainerPinkDT: "#6D3350",
  primaryContainerRoseLT: "#FDA6B3",
  primaryContainerRoseDT: "#72333F",
  primaryContainerRedLT: "#FDA499",
  primaryContainerRedDT: "#73342C",
  primaryContainerOrangeLT: "#FFAE7F",
  primaryContainerOrangeDT: "#6F3812",
  primaryContainerYellowLT: "#FFD57D",
  primaryContainerYellowDT: "#6D5000",
  primaryContainerChartreuseLT: "#DDE692",
  primaryContainerChartreuseDT: "#434B06",
  primaryContainerGreenLT: "#B7F1B9",
  primaryContainerGreenDT: "#1D5128",
  primaryContainerTealLT: "#9EF2E3",
  primaryContainerTealDT: "#006B5F",
  primaryContainerCyanLT: "#9AE5FD",
  primaryContainerCyanDT: "#00677C",
  primaryContainerBlueLT: "#ADC3FE",
  primaryContainerBlueDT: "#2E4578",
  primaryContainerIndigoLT: "#C1BDFE",
  primaryContainerIndigoDT: "#444078",
  primaryContainerPurpleLT: "#D9BDFE",
  primaryContainerPurpleDT: "#523C73",
  onPrimaryContainerLight: "#4F378A",
  onPrimaryContainerLightHighContrast: "#FFFFFF",
  onPrimaryContainerLightMediumContrast: "#FFFFFF",
  onPrimaryContainerDark: "#EADDFF",
  onPrimaryContainerDarkHighContrast: "#000000",
  onPrimaryContainerDarkMediumContrast: "#000000",
  onPrimaryContainerMonochromeLT: "#FFFFFF",
  onPrimaryContainerMonochromeDT: "#000000",
  onPrimaryContainerPinkLT: "#6E334F",
  onPrimaryContainerPinkDT: "#FFD8E6",
  onPrimaryContainerRoseLT: "#72323F",
  onPrimaryContainerRoseDT: "#FFD9DD",
  onPrimaryContainerRedLT: "#73332C",
  onPrimaryContainerRedDT: "#FFDAD5",
  onPrimaryContainerOrangeLT: "#673C22",
  onPrimaryContainerOrangeDT: "#FFDBC9",
  onPrimaryContainerYellowLT: "#544522",
  onPrimaryContainerYellowDT: "#FFF7EF",
  onPrimaryContainerChartreuseLT: "#454A23",
  onPrimaryContainerChartreuseDT: "#DFE995",
  onPrimaryContainerGreenLT: "#2D4E30",
  onPrimaryContainerGreenDT: "#B7F1B9",
  onPrimaryContainerTealLT: "#2E4C47",
  onPrimaryContainerTealDT: "#FFFFFF",
  onPrimaryContainerCyanLT: "#2F4B54",
  onPrimaryContainerCyanDT: "#FFFFFF",
  onPrimaryContainerBlueLT: "#324574",
  onPrimaryContainerBlueDT: "#D9E2FF",
  onPrimaryContainerIndigoLT: "#434078",
  onPrimaryContainerIndigoDT: "#E3DFFF",
  onPrimaryContainerPurpleLT: "#523C72",
  onPrimaryContainerPurpleDT: "#EDDCFF",
  secondaryLight: "#625B71",
  secondaryLightHighContrast: "#27174E",
  secondaryLightMediumContrast: "#493971",
  secondaryDark: "#CCC2DC",
  secondaryDarkHighContrast: "#FFF9FF",
  secondaryDarkMediumContrast: "#D3C1FF",
  secondaryMonochromeLT: "#5F5E5F",
  secondaryMonochromeDT: "#C6C6C6",
  secondaryPinkLT: "#735762",
  secondaryPinkDT: "#E1BDCA",
  secondaryRoseLT: "#76575B",
  secondaryRoseDT: "#E5BDC1",
  secondaryRedLT: "#785753",
  secondaryRedDT: "#E7BDB7",
  secondaryOrangeLT: "#765948",
  secondaryOrangeDT: "#E5BFAA",
  secondaryYellowLT: "#6C5D40",
  secondaryYellowDT: "#D8C4A0",
  secondaryChartreuseLT: "#5E6145",
  secondaryChartreuseDT: "#C6C9A7",
  secondaryGreenLT: "#526451",
  secondaryGreenDT: "#B8CCB5",
  secondaryTealLT: "#4B645F",
  secondaryTealDT: "#B1CCC6",
  secondaryCyanLT: "#4C636A",
  secondaryCyanDT: "#B3CAD3",
  secondaryBlueLT: "#585F72",
  secondaryBlueDT: "#C0C6DC",
  secondaryIndigoLT: "#5F5D72",
  secondaryIndigoDT: "#C7C4DC",
  secondaryPurpleLT: "#655B70",
  secondaryPurpleDT: "#CEC2DA",
  onSecondaryLight: "#FFFFFF",
  onSecondaryLightHighContrast: "#FFFFFF",
  onSecondaryLightMediumContrast: "#FFFFFF",
  onSecondaryDark: "#332D41",
  onSecondaryDarkHighContrast: "#000000",
  onSecondaryDarkMediumContrast: "#1B0942",
  onSecondaryMonochromeLT: "#FFFFFF",
  onSecondaryMonochromeDT: "#1A1C1C",
  onSecondaryPinkLT: "#FFFFFF",
  onSecondaryPinkDT: "#412A34",
  onSecondaryRoseLT: "#FFFFFF",
  onSecondaryRoseDT: "#43292D",
  onSecondaryRedLT: "#FFFFFF",
  onSecondaryRedDT: "#442926",
  onSecondaryOrangeLT: "#FFFFFF",
  onSecondaryOrangeDT: "#432B1D",
  onSecondaryYellowLT: "#FFFFFF",
  onSecondaryYellowDT: "#3B2F15",
  onSecondaryChartreuseLT: "#FFFFFF",
  onSecondaryChartreuseDT: "#2F321A",
  onSecondaryGreenLT: "#FFFFFF",
  onSecondaryGreenDT: "#243425",
  onSecondaryTealLT: "#FFFFFF",
  onSecondaryTealDT: "#1C3530",
  onSecondaryCyanLT: "#FFFFFF",
  onSecondaryCyanDT: "#1D343B",
  onSecondaryBlueLT: "#FFFFFF",
  onSecondaryBlueDT: "#293042",
  onSecondaryIndigoLT: "#FFFFFF",
  onSecondaryIndigoDT: "#302E42",
  onSecondaryPurpleLT: "#FFFFFF",
  onSecondaryPurpleDT: "#352D40",
  secondaryContainerLight: "#E8DEF8",
  secondaryContainerLightHighContrast: "#493971",
  secondaryContainerLightMediumContrast: "#7C6BA7",
  secondaryContainerDark: "#4A4458",
  secondaryContainerDarkHighContrast: "#D3C1FF",
  secondaryContainerDarkMediumContrast: "#9887C5",
  secondaryContainerMonochromeLT: "#D4D4D4",
  secondaryContainerMonochromeDT: "#474747",
  secondaryContainerPinkLT: "#FBD6E3",
  secondaryContainerPinkDT: "#59404A",
  secondaryContainerRoseLT: "#FFD5DA",
  secondaryContainerRoseDT: "#5C3F43",
  secondaryContainerRedLT: "#FFD3CD",
  secondaryContainerRedDT: "#5D3F3B",
  secondaryContainerOrangeLT: "#FDD5BF",
  secondaryContainerOrangeDT: "#5C4131",
  secondaryContainerYellowLT: "#F2DDB8",
  secondaryContainerYellowDT: "#52452A",
  secondaryContainerChartreuseLT: "#E3E5C1",
  secondaryContainerChartreuseDT: "#46492F",
  secondaryContainerGreenLT: "#D1E5CE",
  secondaryContainerGreenDT: "#3A4B3A",
  secondaryContainerTealLT: "#CAE6DF",
  secondaryContainerTealDT: "#334B47",
  secondaryContainerCyanLT: "#CEE7F0",
  secondaryContainerCyanDT: "#344A52",
  secondaryContainerBlueLT: "#D9DFF6",
  secondaryContainerBlueDT: "#404659",
  secondaryContainerIndigoLT: "#E0DDF6",
  secondaryContainerIndigoDT: "#464559",
  secondaryContainerPurpleLT: "#EBDDF7",
  secondaryContainerPurpleDT: "#4C4357",
  onSecondaryContainer: "#4A4459",
  onSecondaryContainerLight: "#4A4459",
  onSecondaryContainerLightHighContrast: "#FFFFFF",
  onSecondaryContainerLightMediumContrast: "#FFFFFF",
  onSecondaryContainerDark: "#E8DEF8",
  onSecondaryContainerDarkHighContrast: "#000000",
  onSecondaryContainerDarkMediumContrast: "#000000",
  onSecondaryContainerMonochromeLT: "#1B1B1B",
  onSecondaryContainerMonochromeDT: "#E2E2E2",
  onSecondaryContainerPinkLT: "#593F4B",
  onSecondaryContainerPinkDT: "#FED9E6",
  onSecondaryContainerRoseLT: "#5C3F43",
  onSecondaryContainerRoseDT: "#FFD9DD",
  onSecondaryContainerRedLT: "#5D3F3B",
  onSecondaryContainerRedDT: "#FFDAD5",
  onSecondaryContainerOrangeLT: "#5C4131",
  onSecondaryContainerOrangeDT: "#FFDBC9",
  onSecondaryContainerYellowLT: "#52452A",
  onSecondaryContainerYellowDT: "#F5E0BB",
  onSecondaryContainerChartreuseLT: "#46492F",
  onSecondaryContainerChartreuseDT: "#E3E5C2",
  onSecondaryContainerGreenLT: "#3A4B3A",
  onSecondaryContainerGreenDT: "#D4E8D1",
  onSecondaryContainerTealLT: "#334B47",
  onSecondaryContainerTealDT: "#CCE8E2",
  onSecondaryContainerCyanLT: "#344A52",
  onSecondaryContainerCyanDT: "#CEE6F0",
  onSecondaryContainerBlueLT: "#404659",
  onSecondaryContainerBlueDT: "#DCE2F9",
  onSecondaryContainerIndigoLT: "#454559",
  onSecondaryContainerIndigoDT: "#E4DFF9",
  onSecondaryContainerPurpleLT: "#4C4357",
  onSecondaryContainerPurpleDT: "#EBDDF7",
  tertiaryLight: "#7D5260",
  tertiaryLightHighContrast: "#420E24",
  tertiaryLightMediumContrast: "#6B2F45",
  tertiaryDark: "#EFB8C8",
  tertiaryDarkHighContrast: "#FFF9F9",
  tertiaryDarkMediumContrast: "#FFB7CD",
  tertiaryMonochromeLT: "#3A3C3C",
  tertiaryMonochromeDT: "#E2E2E2",
  tertiaryPinkLT: "#7F5639",
  tertiaryPinkDT: "#F2BB98",
  tertiaryRoseLT: "#7A5932",
  tertiaryRoseDT: "#EABF8F",
  tertiaryRedLT: "#715C2F",
  tertiaryRedDT: "#DFC38C",
  tertiaryOrangeLT: "#636133",
  tertiaryOrangeDT: "#CDC991",
  tertiaryYellowLT: "#4B6647",
  tertiaryYellowDT: "#B0CFA9",
  tertiaryChartreuseLT: "#3C675B",
  tertiaryChartreuseDT: "#A2D0C2",
  tertiaryGreenLT: "#3A666D",
  tertiaryGreenDT: "#A1CED6",
  tertiaryTealLT: "#45627A",
  tertiaryTealDT: "#ACCAE5",
  tertiaryCyanLT: "#595D7E",
  tertiaryCyanDT: "#C1C4EB",
  tertiaryBlueLT: "#735573",
  tertiaryBlueDT: "#E0BBDD",
  tertiaryIndigoLT: "#7B5368",
  tertiaryIndigoDT: "#EBB8D0",
  tertiaryPurpleLT: "#80525C",
  tertiaryPurpleDT: "#F2B7C2",
  onTertiaryLight: "#FFFFFF",
  onTertiaryLightHighContrast: "#FFFFFF",
  onTertiaryLightMediumContrast: "#FFFFFF",
  onTertiaryDark: "#492532",
  onTertiaryDarkHighContrast: "#000000",
  onTertiaryDarkMediumContrast: "#330218",
  onTertiaryMonochromeLT: "#E2E2E2",
  onTertiaryMonochromeDT: "#1A1C1C",
  onTertiaryPinkLT: "#FFFFFF",
  onTertiaryPinkDT: "#49280F",
  onTertiaryRoseLT: "#FFFFFF",
  onTertiaryRoseDT: "#452B07",
  onTertiaryRedLT: "#FFFFFF",
  onTertiaryRedDT: "#3F2E04",
  onTertiaryOrangeLT: "#FFFFFF",
  onTertiaryOrangeDT: "#333208",
  onTertiaryYellowLT: "#FFFFFF",
  onTertiaryYellowDT: "#1D361C",
  onTertiaryChartreuseLT: "#FFFFFF",
  onTertiaryChartreuseDT: "#06372D",
  onTertiaryGreenLT: "#FFFFFF",
  onTertiaryGreenDT: "#00363D",
  onTertiaryTealLT: "#FFFFFF",
  onTertiaryTealDT: "#143349",
  onTertiaryCyanLT: "#FFFFFF",
  onTertiaryCyanDT: "#2A2E4D",
  onTertiaryBlueLT: "#FFFFFF",
  onTertiaryBlueDT: "#412742",
  onTertiaryIndigoLT: "#FFFFFF",
  onTertiaryIndigoDT: "#472538",
  onTertiaryPurpleLT: "#FFFFFF",
  onTertiaryPurpleDT: "#4B252D",
  tertiaryContainerLight: "#FFD8E4",
  tertiaryContainerLightHighContrast: "#6B2F45",
  tertiaryContainerLightMediumContrast: "#A55F77",
  tertiaryContainerDark: "#633B48",
  tertiaryContainerDarkHighContrast: "#FFB7CD",
  tertiaryContainerDarkMediumContrast: "#C57B93",
  tertiaryContainerMonochromeLT: "#747474",
  tertiaryContainerMonochromeDT: "#919191",
  tertiaryContainerPinkLT: "#FEC6A2",
  tertiaryContainerPinkDT: "#633E23",
  tertiaryContainerRoseLT: "#FFD2A1",
  tertiaryContainerRoseDT: "#5E411C",
  tertiaryContainerRedLT: "#FADCA3",
  tertiaryContainerRedDT: "#574419",
  tertiaryContainerOrangeLT: "#E6E2A9",
  tertiaryContainerOrangeDT: "#4A481D",
  tertiaryContainerYellowLT: "#C9E8C1",
  tertiaryContainerYellowDT: "#334D31",
  tertiaryContainerChartreuseLT: "#BBE9DA",
  tertiaryContainerChartreuseDT: "#224E44",
  tertiaryContainerGreenLT: "#BAE8F0",
  tertiaryContainerGreenDT: "#1F4D54",
  tertiaryContainerTealLT: "#C5E3FF",
  tertiaryContainerTealDT: "#2D4A60",
  tertiaryContainerCyanLT: "#D4D7FF",
  tertiaryContainerCyanDT: "#414465",
  tertiaryContainerBlueLT: "#FBD4F7",
  tertiaryContainerBlueDT: "#593D5A",
  tertiaryContainerIndigoLT: "#FFCCE5",
  tertiaryContainerIndigoDT: "#603B4F",
  tertiaryContainerPurpleLT: "#FDC2CD",
  tertiaryContainerPurpleDT: "#653B43",
  onTertiaryContainerLight: "#633B48",
  onTertiaryContainerLightHighContrast: "#FFFFFF",
  onTertiaryContainerLightMediumContrast: "#FFFFFF",
  onTertiaryContainerDark: "#FFD8E4",
  onTertiaryContainerDarkHighContrast: "#000000",
  onTertiaryContainerDarkMediumContrast: "#000000",
  onTertiaryContainerMonochromeLT: "#FFFFFF",
  onTertiaryContainerMonochromeDT: "#000000",
  onTertiaryContainerPinkLT: "#633E24",
  onTertiaryContainerPinkDT: "#FFDCC6",
  onTertiaryContainerRoseLT: "#5C4122",
  onTertiaryContainerRoseDT: "#FFDDB9",
  onTertiaryContainerRedLT: "#544522",
  onTertiaryContainerRedDT: "#FCDFA6",
  onTertiaryContainerOrangeLT: "#494923",
  onTertiaryContainerOrangeDT: "#E9E5AB",
  onTertiaryContainerYellowLT: "#344D30",
  onTertiaryContainerYellowDT: "#CCEBC4",
  onTertiaryContainerChartreuseLT: "#2E4D44",
  onTertiaryContainerChartreuseDT: "#BEECDD",
  onTertiaryContainerGreenLT: "#2F4B51",
  onTertiaryContainerGreenDT: "#BDEAF3",
  onTertiaryContainerTealLT: "#30495D",
  onTertiaryContainerTealDT: "#CBE6FF",
  onTertiaryContainerCyanLT: "#414465",
  onTertiaryContainerCyanDT: "#DFE0FF",
  onTertiaryContainerBlueLT: "#593D5A",
  onTertiaryContainerBlueDT: "#FDD7FA",
  onTertiaryContainerIndigoLT: "#603C4F",
  onTertiaryContainerIndigoDT: "#FFD8E9",
  onTertiaryContainerPurpleLT: "#653A44",
  onTertiaryContainerPurpleDT: "#FFD9DF",
  errorLight: "#B3261E",
  errorLightHighContrast: "#440F0E",
  errorLightMediumContrast: "#6E2F2C",
  errorDark: "#F2B8B5",
  errorDarkHighContrast: "#FFF9F9",
  errorDarkMediumContrast: "#FFB9B3",
  errorMonochromeLT: "#B3261E",
  errorMonochromeDT: "#F2B8B5",
  errorPinkLT: "#B3261E",
  errorPinkDT: "#F2B8B5",
  errorRoseLT: "#B3261E",
  errorRoseDT: "#F2B8B5",
  errorRedLT: "#B3261E",
  errorRedDT: "#F2B8B5",
  errorOrangeLT: "#B3261E",
  errorOrangeDT: "#F2B8B5",
  errorYellowLT: "#B3261E",
  errorYellowDT: "#F2B8B5",
  errorChartreuseLT: "#B3261E",
  errorChartreuseDT: "#F2B8B5",
  errorGreenLT: "#B3261E",
  errorGreenDT: "#F2B8B5",
  errorTealLT: "#B3261E",
  errorTealDT: "#F2B8B5",
  errorCyanLT: "#B3261E",
  errorCyanDT: "#F2B8B5",
  errorBlueLT: "#B3261E",
  errorBlueDT: "#F2B8B5",
  errorIndigoLT: "#B3261E",
  errorIndigoDT: "#F2B8B5",
  errorPurpleLT: "#B3261E",
  errorPurpleDT: "#F2B8B5",
  onErrorLight: "#FFFFFF",
  onErrorLightHighContrast: "#FFFFFF",
  onErrorLightMediumContrast: "#FFFFFF",
  onErrorDark: "#601410",
  onErrorDarkHighContrast: "#000000",
  onErrorDarkMediumContrast: "#330405",
  onErrorMonochromeLT: "#FFFFFF",
  onErrorMonochromeDT: "#601410",
  onErrorPinkLT: "#FFFFFF",
  onErrorPinkDT: "#601410",
  onErrorRoseLT: "#FFFFFF",
  onErrorRoseDT: "#601410",
  onErrorRedLT: "#FFFFFF",
  onErrorRedDT: "#601410",
  onErrorOrangeLT: "#FFFFFF",
  onErrorOrangeDT: "#601410",
  onErrorYellowLT: "#FFFFFF",
  onErrorYellowDT: "#601410",
  onErrorChartreuseLT: "#FFFFFF",
  onErrorChartreuseDT: "#601410",
  onErrorGreenLT: "#FFFFFF",
  onErrorGreenDT: "#601410",
  onErrorTealLT: "#FFFFFF",
  onErrorTealDT: "#601410",
  onErrorCyanLT: "#FFFFFF",
  onErrorCyanDT: "#601410",
  onErrorBlueLT: "#FFFFFF",
  onErrorBlueDT: "#601410",
  onErrorIndigoLT: "#FFFFFF",
  onErrorIndigoDT: "#601410",
  onErrorPurpleLT: "#FFFFFF",
  onErrorPurpleDT: "#601410",
  errorContainerLight: "#F9DEDC",
  errorContainerLightHighContrast: "#6E2F2C",
  errorContainerLightMediumContrast: "#AA5F5A",
  errorContainerDark: "#8C1D18",
  errorContainerDarkHighContrast: "#FFB9B3",
  errorContainerDarkMediumContrast: "#CC7B74",
  errorContainerMonochromeLT: "#F9DEDC",
  errorContainerMonochromeDT: "#8C1D18",
  errorContainerPinkLT: "#F9DEDC",
  errorContainerPinkDT: "#8C1D18",
  errorContainerRoseLT: "#F9DEDC",
  errorContainerRoseDT: "#8C1D18",
  errorContainerRedLT: "#F9DEDC",
  errorContainerRedDT: "#8C1D18",
  errorContainerOrangeLT: "#F9DEDC",
  errorContainerOrangeDT: "#8C1D18",
  errorContainerYellowLT: "#F9DEDC",
  errorContainerYellowDT: "#8C1D18",
  errorContainerChartreuseLT: "#F9DEDC",
  errorContainerChartreuseDT: "#8C1D18",
  errorContainerGreenLT: "#F9DEDC",
  errorContainerGreenDT: "#8C1D18",
  errorContainerTealLT: "#F9DEDC",
  errorContainerTealDT: "#8C1D18",
  errorContainerCyanLT: "#F9DEDC",
  errorContainerCyanDT: "#8C1D18",
  errorContainerBlueLT: "#F9DEDC",
  errorContainerBlueDT: "#8C1D18",
  errorContainerIndigoLT: "#F9DEDC",
  errorContainerIndigoDT: "#8C1D18",
  errorContainerPurpleLT: "#F9DEDC",
  errorContainerPurpleDT: "#8C1D18",
  onErrorContainerLight: "#852221",
  onErrorContainerLightHighContrast: "#FFFFFF",
  onErrorContainerLightMediumContrast: "#FFFFFF",
  onErrorContainerDark: "#F9DEDC",
  onErrorContainerDarkHighContrast: "#000000",
  onErrorContainerDarkMediumContrast: "#000000",
  onErrorContainerMonochromeLT: "#410E0B",
  onErrorContainerMonochromeDT: "#F2B8B5",
  onErrorContainerPinkLT: "#8C1D18",
  onErrorContainerPinkDT: "#F9DEDC",
  onErrorContainerRoseLT: "#8C1D18",
  onErrorContainerRoseDT: "#F9DEDC",
  onErrorContainerRedLT: "#8C1D18",
  onErrorContainerRedDT: "#F9DEDC",
  onErrorContainerOrangeLT: "#8C1D18",
  onErrorContainerOrangeDT: "#F9DEDC",
  onErrorContainerYellowLT: "#8C1D18",
  onErrorContainerYellowDT: "#F9DEDC",
  onErrorContainerChartreuseLT: "#8C1D18",
  onErrorContainerChartreuseDT: "#F9DEDC",
  onErrorContainerGreenLT: "#8C1D18",
  onErrorContainerGreenDT: "#F9DEDC",
  onErrorContainerTealLT: "#8C1D18",
  onErrorContainerTealDT: "#F9DEDC",
  onErrorContainerCyanLT: "#8C1D18",
  onErrorContainerCyanDT: "#F9DEDC",
  onErrorContainerBlueLT: "#8C1D18",
  onErrorContainerBlueDT: "#F9DEDC",
  onErrorContainerIndigoLT: "#8C1D18",
  onErrorContainerIndigoDT: "#F9DEDC",
  onErrorContainerPurpleLT: "#8C1D18",
  onErrorContainerPurpleDT: "#F9DEDC",
  backgroundLight: "#FEF7FF",
  backgroundLightHighContrast: "#FDF7FF",
  backgroundLightMediumContrast: "#FDF7FF",
  backgroundDark: "#141218",
  backgroundDarkHighContrast: "#141218",
  backgroundDarkMediumContrast: "#141218",
  backgroundMonochromeLT: "#FDF7FF",
  backgroundMonochromeDT: "#141218",
  backgroundPinkLT: "#FDF7FF",
  backgroundPinkDT: "#141218",
  backgroundRoseLT: "#FDF7FF",
  backgroundRoseDT: "#141218",
  backgroundRedLT: "#FDF7FF",
  backgroundRedDT: "#141218",
  backgroundOrangeLT: "#FDF7FF",
  backgroundOrangeDT: "#141218",
  backgroundYellowLT: "#FDF7FF",
  backgroundYellowDT: "#141218",
  backgroundChartreuseLT: "#FDF7FF",
  backgroundChartreuseDT: "#141218",
  backgroundGreenLT: "#FDF7FF",
  backgroundGreenDT: "#141218",
  backgroundTealLT: "#FDF7FF",
  backgroundTealDT: "#141218",
  backgroundCyanLT: "#FDF7FF",
  backgroundCyanDT: "#141218",
  backgroundBlueLT: "#FDF7FF",
  backgroundBlueDT: "#141218",
  backgroundIndigoLT: "#FDF7FF",
  backgroundIndigoDT: "#141218",
  backgroundPurpleLT: "#FDF7FF",
  backgroundPurpleDT: "#141218",
  onBackgroundLight: "#1D1B20",
  onBackgroundLightHighContrast: "#1D1B20",
  onBackgroundLightMediumContrast: "#1D1B20",
  onBackgroundDark: "#E6E0E9",
  onBackgroundDarkHighContrast: "#E6E0E9",
  onBackgroundDarkMediumContrast: "#E6E0E9",
  onBackgroundMonochromeLT: "#1D1B20",
  onBackgroundMonochromeDT: "#E6E0E9",
  onBackgroundPinkLT: "#1D1B20",
  onBackgroundPinkDT: "#E6E0E9",
  onBackgroundRoseLT: "#1D1B20",
  onBackgroundRoseDT: "#E6E0E9",
  onBackgroundRedLT: "#1D1B20",
  onBackgroundRedDT: "#E6E0E9",
  onBackgroundOrangeLT: "#1D1B20",
  onBackgroundOrangeDT: "#E6E0E9",
  onBackgroundYellowLT: "#1D1B20",
  onBackgroundYellowDT: "#E6E0E9",
  onBackgroundChartreuseLT: "#1D1B20",
  onBackgroundChartreuseDT: "#E6E0E9",
  onBackgroundGreenLT: "#1D1B20",
  onBackgroundGreenDT: "#E6E0E9",
  onBackgroundTealLT: "#1D1B20",
  onBackgroundTealDT: "#E6E0E9",
  onBackgroundCyanLT: "#1D1B20",
  onBackgroundCyanDT: "#E6E0E9",
  onBackgroundBlueLT: "#1D1B20",
  onBackgroundBlueDT: "#E6E0E9",
  onBackgroundIndigoLT: "#1D1B20",
  onBackgroundIndigoDT: "#E6E0E9",
  onBackgroundPurpleLT: "#1D1B20",
  onBackgroundPurpleDT: "#E6E0E9",
  surfaceLight: "#FEF7FF",
  surfaceLightHighContrast: "#FDF7FF",
  surfaceLightMediumContrast: "#FDF7FF",
  surfaceDark: "#141218",
  surfaceDarkHighContrast: "#141218",
  surfaceDarkMediumContrast: "#141218",
  surfaceMonochromeLT: "#F9F9F9",
  surfaceMonochromeDT: "#131313",
  surfacePinkLT: "#FFF8F8",
  surfacePinkDT: "#191114",
  surfaceRoseLT: "#FFF8F7",
  surfaceRoseDT: "#191112",
  surfaceRedLT: "#FFF8F7",
  surfaceRedDT: "#1A1110",
  surfaceOrangeLT: "#FFF8F5",
  surfaceOrangeDT: "#1A120D",
  surfaceYellowLT: "#FFF8F2",
  surfaceYellowDT: "#17130B",
  surfaceChartreuseLT: "#FCFAED",
  surfaceChartreuseDT: "#13140D",
  surfaceGreenLT: "#F7FBF2",
  surfaceGreenDT: "#101510",
  surfaceTealLT: "#F4FBF8",
  surfaceTealDT: "#0E1513",
  surfaceCyanLT: "#F5FAFD",
  surfaceCyanDT: "#0F1416",
  surfaceBlueLT: "#FAF8FF",
  surfaceBlueDT: "#121318",
  surfaceIndigoLT: "#FCF8FF",
  surfaceIndigoDT: "#131318",
  surfacePurpleLT: "#FEF7FF",
  surfacePurpleDT: "#151218",
  onSurfaceLight: "#1D1B20",
  onSurfaceLightHighContrast: "#000000",
  onSurfaceLightMediumContrast: "#1D1B20",
  onSurfaceDark: "#E6E0E9",
  onSurfaceDarkHighContrast: "#FFFFFF",
  onSurfaceDarkMediumContrast: "#FFF9FF",
  onSurfaceMonochromeLT: "#1B1B1B",
  onSurfaceMonochromeDT: "#E2E2E2",
  onSurfacePinkLT: "#21191C",
  onSurfacePinkDT: "#EEDFE3",
  onSurfaceRoseLT: "#22191A",
  onSurfaceRoseDT: "#F0DEDF",
  onSurfaceRedLT: "#231918",
  onSurfaceRedDT: "#F1DEDC",
  onSurfaceOrangeLT: "#221A15",
  onSurfaceOrangeDT: "#F0DFD7",
  onSurfaceYellowLT: "#1F1B13",
  onSurfaceYellowDT: "#EBE1D4",
  onSurfaceChartreuseLT: "#1B1C14",
  onSurfaceChartreuseDT: "#E5E3D6",
  onSurfaceGreenLT: "#181D18",
  onSurfaceGreenDT: "#E0E4DB",
  onSurfaceTealLT: "#171D1B",
  onSurfaceTealDT: "#DDE4E1",
  onSurfaceCyanLT: "#171C1E",
  onSurfaceCyanDT: "#DEE3E6",
  onSurfaceBlueLT: "#1A1B21",
  onSurfaceBlueDT: "#E2E2E9",
  onSurfaceIndigoLT: "#1C1B21",
  onSurfaceIndigoDT: "#E5E1E9",
  onSurfacePurpleLT: "#1D1A20",
  onSurfacePurpleDT: "#E7E0E8",
  surfaceVariantLight: "#E7E0EC",
  surfaceVariantLightHighContrast: "#E7E0EB",
  surfaceVariantLightMediumContrast: "#E7E0EB",
  surfaceVariantDark: "#49454F",
  surfaceVariantDarkHighContrast: "#49454E",
  surfaceVariantDarkMediumContrast: "#49454E",
  surfaceVariantMonochromeLT: "#E2E2E2",
  surfaceVariantMonochromeDT: "#474747",
  surfaceVariantPinkLT: "#EEDFE3",
  surfaceVariantPinkDT: "#3B3235",
  surfaceVariantRoseLT: "#F0DEDF",
  surfaceVariantRoseDT: "#3D3233",
  surfaceVariantRedLT: "#F1DEDC",
  surfaceVariantRedDT: "#3D3231",
  surfaceVariantOrangeLT: "#F0DFD7",
  surfaceVariantOrangeDT: "#3D332D",
  surfaceVariantYellowLT: "#EBE1D4",
  surfaceVariantYellowDT: "#39342B",
  surfaceVariantChartreuseLT: "#E5E3D6",
  surfaceVariantChartreuseDT: "#35352D",
  surfaceVariantGreenLT: "#E0E4DB",
  surfaceVariantGreenDT: "#313630",
  surfaceVariantTealLT: "#DDE4E1",
  surfaceVariantTealDT: "#303634",
  surfaceVariantCyanLT: "#DEE3E6",
  surfaceVariantCyanDT: "#303638",
  surfaceVariantBlueLT: "#E2E2E9",
  surfaceVariantBlueDT: "#33343A",
  surfaceVariantIndigoLT: "#E5E1E9",
  surfaceVariantIndigoDT: "#35343A",
  surfaceVariantPurpleLT: "#E7E0E8",
  surfaceVariantPurpleDT: "#37333A",
  onSurfaceVariantLight: "#49454F",
  onSurfaceVariantLightHighContrast: "#25232B",
  onSurfaceVariantLightMediumContrast: "#45414A",
  onSurfaceVariantDark: "#CAC4D0",
  onSurfaceVariantDarkHighContrast: "#FFF9FF",
  onSurfaceVariantDarkMediumContrast: "#CEC8D4",
  onSurfaceVariantMonochromeLT: "#474747",
  onSurfaceVariantMonochromeDT: "#C6C6C6",
  onSurfaceVariantPinkLT: "#504348",
  onSurfaceVariantPinkDT: "#D4C2C7",
  onSurfaceVariantRoseLT: "#524345",
  onSurfaceVariantRoseDT: "#D7C2C3",
  onSurfaceVariantRedLT: "#534341",
  onSurfaceVariantRedDT: "#D8C2BE",
  onSurfaceVariantOrangeLT: "#52443C",
  onSurfaceVariantOrangeDT: "#D7C2B8",
  onSurfaceVariantYellowLT: "#4D4639",
  onSurfaceVariantYellowDT: "#D0C5B4",
  onSurfaceVariantChartreuseLT: "#47483B",
  onSurfaceVariantChartreuseDT: "#C8C7B7",
  onSurfaceVariantGreenLT: "#424940",
  onSurfaceVariantGreenDT: "#C1C9BE",
  onSurfaceVariantTealLT: "#3F4946",
  onSurfaceVariantTealDT: "#BEC9C5",
  onSurfaceVariantCyanLT: "#40484B",
  onSurfaceVariantCyanDT: "#BFC8CC",
  onSurfaceVariantBlueLT: "#44464F",
  onSurfaceVariantBlueDT: "#C5C6D0",
  onSurfaceVariantIndigoLT: "#47464F",
  onSurfaceVariantIndigoDT: "#C8C5D0",
  onSurfaceVariantPurpleLT: "#4A454E",
  onSurfaceVariantPurpleDT: "#CBC4CF",
  onSurfaceSubtleLight: "#6F797B",
  outlineLight: "#79747E",
  outlineLightHighContrast: "#45414A",
  outlineLightMediumContrast: "#615D67",
  outlineDark: "#938F99",
  outlineDarkHighContrast: "#CEC8D4",
  outlineDarkMediumContrast: "#A6A1AB",
  outlineMonochromeLT: "#777777",
  outlineMonochromeDT: "#919191",
  outlinePinkLT: "#827378",
  outlinePinkDT: "#9D8C92",
  outlineRoseLT: "#847374",
  outlineRoseDT: "#9F8C8E",
  outlineRedLT: "#857370",
  outlineRedDT: "#A08C8A",
  outlineOrangeLT: "#85746B",
  outlineOrangeDT: "#7F7667",
  outlineYellowLT: "#7F7667",
  outlineYellowDT: "#999080",
  outlineChartreuseLT: "#78786A",
  outlineChartreuseDT: "#919282",
  outlineGreenLT: "#717970",
  outlineGreenDT: "#919282",
  outlineTealLT: "#6F7976",
  outlineTealDT: "#88938F",
  outlineCyanLT: "#70787C",
  outlineCyanDT: "#8A9295",
  outlineBlueLT: "#757780",
  outlineBlueDT: "#8F909A",
  outlineIndigoLT: "#787680",
  outlineIndigoDT: "#918F9A",
  outlinePurpleLT: "#7A757F",
  outlinePurpleDT: "#958E99",
  outlineVariantLight: "#CAC4D0",
  outlineVariantLightHighContrast: "#45414A",
  outlineVariantLightMediumContrast: "#7D7983",
  outlineVariantDark: "#49454F",
  outlineVariantDarkHighContrast: "#CEC8D4",
  outlineVariantDarkMediumContrast: "#86818B",
  outlineVariantMonochromeLT: "#C6C6C6",
  outlineVariantMonochromeDT: "#474747",
  outlineVariantPinkLT: "#D4C2C7",
  outlineVariantPinkDT: "#504348",
  outlineVariantRoseLT: "#D7C2C3",
  outlineVariantRoseDT: "#524345",
  outlineVariantRedLT: "#D8C2BE",
  outlineVariantRedDT: "#534341",
  outlineVariantOrangeLT: "#D7C2B8",
  outlineVariantOrangeDT: "#52443C",
  outlineVariantYellowLT: "#D0C5B4",
  outlineVariantYellowDT: "#4D4639",
  outlineVariantChartreuseLT: "#C8C7B7",
  outlineVariantChartreuseDT: "#47483B",
  outlineVariantGreenLT: "#C1C9BE",
  outlineVariantGreenDT: "#424940",
  outlineVariantTealLT: "#BEC9C5",
  outlineVariantTealDT: "#3F4946",
  outlineVariantCyanLT: "#BFC8CC",
  outlineVariantCyanDT: "#40484B",
  outlineVariantBlueLT: "#C5C6D0",
  outlineVariantBlueDT: "#44464F",
  outlineVariantIndigoLT: "#C8C5D0",
  outlineVariantIndigoDT: "#47464F",
  outlineVariantPurpleLT: "#CBC4CF",
  outlineVariantPurpleDT: "#4A454E",
  surfaceTintLight: "#6750A4",
  surfaceTintLightHighContrast: "#65558F",
  surfaceTintLightMediumContrast: "#65558F",
  surfaceTintDark: "#D0BCFF",
  surfaceTintDarkHighContrast: "#CFBDFE",
  surfaceTintDarkMediumContrast: "#CFBDFE",
  surfaceTintMonochromeLT: "#9F9F9F",
  surfaceTintMonochromeDT: "#E8E8E8",
  surfaceTintPinkLT: "#8A4B68",
  surfaceTintPinkDT: "#FEB0D1",
  surfaceTintRoseLT: "#8F4A56",
  surfaceTintRoseDT: "#FFB2BD",
  surfaceTintRedLT: "#914B43",
  surfaceTintRedDT: "#FFA79B",
  surfaceTintOrangeLT: "#8D4F28",
  surfaceTintOrangeDT: "#FFB68C",
  surfaceTintYellowLT: "#795A0C",
  surfaceTintYellowDT: "#E9C16C",
  surfaceTintChartreuseLT: "#5C641E",
  surfaceTintChartreuseDT: "#C3CD7C",
  surfaceTintGreenLT: "#376A3E",
  surfaceTintGreenDT: "#9CD49F",
  surfaceTintTealLT: "#006B60",
  surfaceTintTealDT: "#82D5C7",
  surfaceTintCyanLT: "#01687D",
  surfaceTintCyanDT: "#86D1EA",
  surfaceTintBlueLT: "#485E92",
  surfaceTintBlueDT: "#B0C6FF",
  surfaceTintIndigoLT: "#5B5992",
  surfaceTintIndigoDT: "#C5C0FF",
  surfaceTintPurpleLT: "#6B548D",
  surfaceTintPurpleDT: "#D6BBFB",
  shadowLight: "#000000",
  shadowLightHighContrast: "#000000",
  shadowLightMediumContrast: "#000000",
  shadowDark: "#000000",
  shadowDarkHighContrast: "#000000",
  shadowDarkMediumContrast: "#000000",
  shadowMonochromeLT: "#000000",
  shadowMonochromeDT: "#000000",
  shadowPinkLT: "#000000",
  shadowPinkDT: "#000000",
  shadowRoseLT: "#000000",
  shadowRoseDT: "#000000",
  shadowRedLT: "#000000",
  shadowRedDT: "#000000",
  shadowOrangeLT: "#000000",
  shadowOrangeDT: "#000000",
  shadowYellowLT: "#000000",
  shadowYellowDT: "#000000",
  shadowChartreuseLT: "#000000",
  shadowChartreuseDT: "#000000",
  shadowGreenLT: "#000000",
  shadowGreenDT: "#000000",
  shadowTealLT: "#000000",
  shadowTealDT: "#000000",
  shadowCyanLT: "#000000",
  shadowCyanDT: "#000000",
  shadowBlueLT: "#000000",
  shadowBlueDT: "#000000",
  shadowIndigoLT: "#000000",
  shadowIndigoDT: "#000000",
  shadowPurpleLT: "#000000",
  shadowPurpleDT: "#000000",
  scrimLight: "#000000",
  scrimLightHighContrast: "#000000",
  scrimLightMediumContrast: "#000000",
  scrimDark: "#000000",
  scrimDarkHighContrast: "#000000",
  scrimDarkMediumContrast: "#000000",
  scrimMonochromeLT: "#000000",
  scrimMonochromeDT: "#000000",
  scrimPinkLT: "#000000",
  scrimPinkDT: "#000000",
  scrimRoseLT: "#000000",
  scrimRoseDT: "#000000",
  scrimRedLT: "#000000",
  scrimRedDT: "#000000",
  scrimOrangeLT: "#000000",
  scrimOrangeDT: "#000000",
  scrimYellowLT: "#000000",
  scrimYellowDT: "#000000",
  scrimChartreuseLT: "#000000",
  scrimChartreuseDT: "#000000",
  scrimGreenLT: "#000000",
  scrimGreenDT: "#000000",
  scrimTealLT: "#000000",
  scrimTealDT: "#000000",
  scrimCyanLT: "#000000",
  scrimCyanDT: "#000000",
  scrimBlueLT: "#000000",
  scrimBlueDT: "#000000",
  scrimIndigoLT: "#000000",
  scrimIndigoDT: "#000000",
  scrimPurpleLT: "#000000",
  scrimPurpleDT: "#000000",
  inverseSurfaceLight: "#322F35",
  inverseSurfaceLightHighContrast: "#322F35",
  inverseSurfaceLightMediumContrast: "#322F35",
  inverseSurfaceDark: "#E6E0E9",
  inverseSurfaceDarkHighContrast: "#E6E0E9",
  inverseSurfaceDarkMediumContrast: "#E6E0E9",
  inverseSurfaceMonochromeLT: "#303030",
  inverseSurfaceMonochromeDT: "#E2E2E2",
  inverseSurfacePinkLT: "#30282B",
  inverseSurfacePinkDT: "#EEDFE3",
  inverseSurfaceRoseLT: "#312829",
  inverseSurfaceRoseDT: "#F0DEDF",
  inverseSurfaceRedLT: "#322826",
  inverseSurfaceRedDT: "#F1DEDC",
  inverseSurfaceOrangeLT: "#312823",
  inverseSurfaceOrangeDT: "#F0DFD7",
  inverseSurfaceYellowLT: "#2E2921",
  inverseSurfaceYellowDT: "#EBE1D4",
  inverseSurfaceChartreuseLT: "#2A2B22",
  inverseSurfaceChartreuseDT: "#E5E3D6",
  inverseSurfaceGreenLT: "#272B26",
  inverseSurfaceGreenDT: "#E0E4DB",
  inverseSurfaceTealLT: "#252B2A",
  inverseSurfaceTealDT: "#DDE4E1",
  inverseSurfaceCyanLT: "#252B2D",
  inverseSurfaceCyanDT: "#DEE3E6",
  inverseSurfaceBlueLT: "#282A2F",
  inverseSurfaceBlueDT: "#E2E2E9",
  inverseSurfaceIndigoLT: "#2A292F",
  inverseSurfaceIndigoDT: "#EDE6EE",
  inverseSurfacePurpleLT: "#2C292F",
  inverseSurfacePurpleDT: "#E7E0E8",
  inverseOnSurfaceLight: "#F5EFF7",
  inverseOnSurfaceLightHighContrast: "#FFFFFF",
  inverseOnSurfaceLightMediumContrast: "#F5EFF7",
  inverseOnSurfaceDark: "#322F35",
  inverseOnSurfaceDarkHighContrast: "#000000",
  inverseOnSurfaceDarkMediumContrast: "#2B292F",
  inverseOnSurfaceMonochromeLT: "#F1F1F1",
  inverseOnSurfaceMonochromeDT: "#303030",
  inverseOnSurfacePinkLT: "#FAEAEE",
  inverseOnSurfacePinkDT: "#3B3235",
  inverseOnSurfaceRoseLT: "#FBEAEB",
  inverseOnSurfaceRoseDT: "#3D3233",
  inverseOnSurfaceRedLT: "#FCEAE7",
  inverseOnSurfaceRedDT: "#3D3231",
  inverseOnSurfaceOrangeLT: "#FCEAE2",
  inverseOnSurfaceOrangeDT: "#3D332D",
  inverseOnSurfaceYellowLT: "#F7ECDF",
  inverseOnSurfaceYellowDT: "#39342B",
  inverseOnSurfaceChartreuseLT: "#F0EEE1",
  inverseOnSurfaceChartreuseDT: "#335533",
  inverseOnSurfaceGreenLT: "#EBEFE7",
  inverseOnSurfaceGreenDT: "#313630",
  inverseOnSurfaceTealLT: "#E9EFEC",
  inverseOnSurfaceTealDT: "#303634",
  inverseOnSurfaceCyanLT: "#EAEFF1",
  inverseOnSurfaceCyanDT: "#303638",
  inverseOnSurfaceBlueLT: "#EEEDF4",
  inverseOnSurfaceBlueDT: "#33343A",
  inverseOnSurfaceIndigoLT: "#F0ECF4",
  inverseOnSurfaceIndigoDT: "#35343A",
  inverseOnSurfacePurpleLT: "#F3ECF4",
  inverseOnSurfacePurpleDT: "#37333A",
  inversePrimaryLight: "#D0BCFF",
  inversePrimaryLightHighContrast: "#F1E8FF",
  inversePrimaryLightMediumContrast: "#CFBDFE",
  inversePrimaryDark: "#6750A4",
  inversePrimaryDarkHighContrast: "#2F2056",
  inversePrimaryDarkMediumContrast: "#4E3F77",
  inversePrimaryMonochromeLT: "#474747",
  inversePrimaryMonochromeDT: "#000000",
  inversePrimaryPinkLT: "#FEB0D1",
  inversePrimaryPinkDT: "#8A4B68",
  inversePrimaryRoseLT: "#FFB2BD",
  inversePrimaryRoseDT: "#8F4A56",
  inversePrimaryRedLT: "#FFA79B",
  inversePrimaryRedDT: "#914B43",
  inversePrimaryOrangeLT: "#FFB68C",
  inversePrimaryOrangeDT: "#8D4F28",
  inversePrimaryYellowLT: "#E9C16C",
  inversePrimaryYellowDT: "#795A0C",
  inversePrimaryChartreuseLT: "#C3CD7C",
  inversePrimaryChartreuseDT: "#5C641E",
  inversePrimaryGreenLT: "#9CD49F",
  inversePrimaryGreenDT: "#376A3E",
  inversePrimaryTealLT: "#82D5C7",
  inversePrimaryTealDT: "#006B60",
  inversePrimaryCyanLT: "#86D1EA",
  inversePrimaryCyanDT: "#01687D",
  inversePrimaryBlueLT: "#B0C6FF",
  inversePrimaryBlueDT: "#485E92",
  inversePrimaryIndigoLT: "#C5C0FF",
  inversePrimaryIndigoDT: "#5B5992",
  inversePrimaryPurpleLT: "#D6BBFB",
  inversePrimaryPurpleDT: "#6B548D",
  primaryFixedLight: "#EADDFF",
  primaryFixedLightHighContrast: "#493971",
  primaryFixedLightMediumContrast: "#7B6BA7",
  primaryFixedDark: "#EADDFF",
  primaryFixedDarkHighContrast: "#EDE2FF",
  primaryFixedDarkMediumContrast: "#E9DDFF",
  primaryFixedMonochromeLT: "#5E5E5E",
  primaryFixedMonochromeDT: "#5E5E5E",
  primaryFixedPinkLT: "#FEB0D1",
  primaryFixedPinkDT: "#FEB0D1",
  primaryFixedRoseLT: "#FDA6B3",
  primaryFixedRoseDT: "#FDA6B3",
  primaryFixedRedLT: "#FDA499",
  primaryFixedRedDT: "#FDA499",
  primaryFixedOrangeLT: "#FFAE7F",
  primaryFixedOrangeDT: "#FFAE7F",
  primaryFixedYellowLT: "#FFD57D",
  primaryFixedYellowDT: "#FFD57D",
  primaryFixedChartreuseLT: "#DDE692",
  primaryFixedChartreuseDT: "#DDE692",
  primaryFixedGreenLT: "#B7F1B9",
  primaryFixedGreenDT: "#B7F1B9",
  primaryFixedTealLT: "#9EF2E3",
  primaryFixedTealDT: "#9EF2E3",
  primaryFixedCyanLT: "#9AE5FD",
  primaryFixedCyanDT: "#9AE5FD",
  primaryFixedBlueLT: "#ADC3FE",
  primaryFixedBlueDT: "#ADC3FE",
  primaryFixedIndigoLT: "#C1BDFE",
  primaryFixedIndigoDT: "#C1BDFE",
  primaryFixedPurpleLT: "#D9BDFE",
  primaryFixedPurpleDT: "#D9BDFE",
  onPrimaryFixedLight: "#21005D",
  onPrimaryFixedLightHighContrast: "#FFFFFF",
  onPrimaryFixedLightMediumContrast: "#FFFFFF",
  onPrimaryFixedDark: "#21005D",
  onPrimaryFixedDarkHighContrast: "#000000",
  onPrimaryFixedDarkMediumContrast: "#16033D",
  onPrimaryFixedMonochromeLT: "#FFFFFF",
  onPrimaryFixedMonochromeDT: "#FFFFFF",
  onPrimaryFixedPinkLT: "#390723",
  onPrimaryFixedPinkDT: "#390723",
  onPrimaryFixedRoseLT: "#3B0715",
  onPrimaryFixedRoseDT: "#3B0715",
  onPrimaryFixedRedLT: "#3B0906",
  onPrimaryFixedRedDT: "#3B0906",
  onPrimaryFixedOrangeLT: "#321200",
  onPrimaryFixedOrangeDT: "#321200",
  onPrimaryFixedYellowLT: "#261A00",
  onPrimaryFixedYellowDT: "#261A00",
  onPrimaryFixedChartreuseLT: "#1A1E00",
  onPrimaryFixedChartreuseDT: "#1A1E00",
  onPrimaryFixedGreenLT: "#002108",
  onPrimaryFixedGreenDT: "#002108",
  onPrimaryFixedTealLT: "#00201C",
  onPrimaryFixedTealDT: "#00201C",
  onPrimaryFixedCyanLT: "#001F27",
  onPrimaryFixedCyanDT: "#001F27",
  onPrimaryFixedBlueLT: "#001946",
  onPrimaryFixedBlueDT: "#001946",
  onPrimaryFixedIndigoLT: "#17134A",
  onPrimaryFixedIndigoDT: "#17134A",
  onPrimaryFixedPurpleLT: "#250E44",
  onPrimaryFixedPurpleDT: "#250E44",
  primaryFixedDimLight: "#D0BCFF",
  primaryFixedDimLightHighContrast: "#322359",
  primaryFixedDimLightMediumContrast: "#62538C",
  primaryFixedDimDark: "#D0BCFF",
  primaryFixedDimDarkHighContrast: "#D3C1FF",
  primaryFixedDimDarkMediumContrast: "#CFBDFE",
  primaryFixedDimMonochromeLT: "#474747",
  primaryFixedDimMonochromeDT: "#474747",
  primaryFixedDimPinkLT: "#E095B5",
  primaryFixedDimPinkDT: "#E095B5",
  primaryFixedDimRoseLT: "#DE8C99",
  primaryFixedDimRoseDT: "#DE8C99",
  primaryFixedDimRedLT: "#DE8A80",
  primaryFixedDimRedDT: "#DE8A80",
  primaryFixedDimOrangeLT: "#E09468",
  primaryFixedDimOrangeDT: "#E09468",
  primaryFixedDimYellowLT: "#E1B964",
  primaryFixedDimYellowDT: "#E1B964",
  primaryFixedDimChartreuseLT: "#C1CA79",
  primaryFixedDimChartreuseDT: "#C1CA79",
  primaryFixedDimGreenLT: "#9CD49E",
  primaryFixedDimGreenDT: "#9CD49E",
  primaryFixedDimTealLT: "#82D5C7",
  primaryFixedDimTealDT: "#82D5C7",
  primaryFixedDimCyanLT: "#7EC9E0",
  primaryFixedDimCyanDT: "#7EC9E0",
  primaryFixedDimBlueLT: "#92A8E1",
  primaryFixedDimBlueDT: "#92A8E1",
  primaryFixedDimIndigoLT: "#A6A2E1",
  primaryFixedDimIndigoDT: "#A6A2E1",
  primaryFixedDimPurpleLT: "#BDA2E1",
  primaryFixedDimPurpleDT: "#BDA2E1",
  onPrimaryFixedVariantLight: "#4F378B",
  onPrimaryFixedVariantLightHighContrast: "#FFFFFF",
  onPrimaryFixedVariantLightMediumContrast: "#FFFFFF",
  onPrimaryFixedVariantDark: "#4F378B",
  onPrimaryFixedVariantDarkHighContrast: "#1B0942",
  onPrimaryFixedVariantDarkMediumContrast: "#3C2D63",
  onPrimaryFixedVariantMonochromeLT: "#E3E2E2",
  onPrimaryFixedVariantMonochromeDT: "#E3E2E2",
  onPrimaryFixedVariantPinkLT: "#6E334F",
  onPrimaryFixedVariantPinkDT: "#6E334F",
  onPrimaryFixedVariantRoseLT: "#72323F",
  onPrimaryFixedVariantRoseDT: "#72323F",
  onPrimaryFixedVariantRedLT: "#73332C",
  onPrimaryFixedVariantRedDT: "#73332C",
  onPrimaryFixedVariantOrangeLT: "#673C22",
  onPrimaryFixedVariantOrangeDT: "#673C22",
  onPrimaryFixedVariantYellowLT: "#544522",
  onPrimaryFixedVariantYellowDT: "#544522",
  onPrimaryFixedVariantChartreuseLT: "#454A23",
  onPrimaryFixedVariantChartreuseDT: "#454A23",
  onPrimaryFixedVariantGreenLT: "#2D4E30",
  onPrimaryFixedVariantGreenDT: "#2D4E30",
  onPrimaryFixedVariantTealLT: "#2E4C47",
  onPrimaryFixedVariantTealDT: "#2E4C47",
  onPrimaryFixedVariantCyanLT: "#2F4B54",
  onPrimaryFixedVariantCyanDT: "#2F4B54",
  onPrimaryFixedVariantBlueLT: "#324574",
  onPrimaryFixedVariantBlueDT: "#324574",
  onPrimaryFixedVariantIndigoLT: "#434078",
  onPrimaryFixedVariantIndigoDT: "#434078",
  onPrimaryFixedVariantPurpleLT: "#523C72",
  onPrimaryFixedVariantPurpleDT: "#523C72",
  secondaryFixedLight: "#E8DEF8",
  secondaryFixedLightHighContrast: "#493971",
  secondaryFixedLightMediumContrast: "#7C6BA7",
  secondaryFixedDark: "#E8DEF8",
  secondaryFixedDarkHighContrast: "#EDE2FF",
  secondaryFixedDarkMediumContrast: "#E9DDFF",
  secondaryFixedMonochromeLT: "#C6C6C6",
  secondaryFixedMonochromeDT: "#C6C6C6",
  secondaryFixedPinkLT: "#FBD6E3",
  secondaryFixedPinkDT: "#FBD6E3",
  secondaryFixedRoseLT: "#FFD5DA",
  secondaryFixedRoseDT: "#FFD5DA",
  secondaryFixedRedLT: "#FFD3CD",
  secondaryFixedRedDT: "#FFD3CD",
  secondaryFixedOrangeLT: "#FDD5BF",
  secondaryFixedOrangeDT: "#FDD5BF",
  secondaryFixedYellowLT: "#F2DDB8",
  secondaryFixedYellowDT: "#F2DDB8",
  secondaryFixedChartreuseLT: "#E3E5C1",
  secondaryFixedChartreuseDT: "#E3E5C1",
  secondaryFixedGreenLT: "#D1E5CE",
  secondaryFixedGreenDT: "#D1E5CE",
  secondaryFixedTealLT: "#CAE6DF",
  secondaryFixedTealDT: "#CAE6DF",
  secondaryFixedCyanLT: "#CEE7F0",
  secondaryFixedCyanDT: "#CEE7F0",
  secondaryFixedBlueLT: "#D9DFF6",
  secondaryFixedBlueDT: "#D9DFF6",
  secondaryFixedIndigoLT: "#E0DDF6",
  secondaryFixedIndigoDT: "#E0DDF6",
  secondaryFixedPurpleLT: "#EBDDF7",
  secondaryFixedPurpleDT: "#EBDDF7",
  onSecondaryFixedLight: "#1D192B",
  onSecondaryFixedLightHighContrast: "#FFFFFF",
  onSecondaryFixedLightMediumContrast: "#FFFFFF",
  onSecondaryFixedDark: "#1D192B",
  onSecondaryFixedDarkHighContrast: "#000000",
  onSecondaryFixedDarkMediumContrast: "#16033D",
  onSecondaryFixedMonochromeLT: "#1B1C1C",
  onSecondaryFixedMonochromeDT: "#1B1C1C",
  onSecondaryFixedPinkLT: "#2A151F",
  onSecondaryFixedPinkDT: "#2A151F",
  onSecondaryFixedRoseLT: "#2C1519",
  onSecondaryFixedRoseDT: "#2C1519",
  onSecondaryFixedRedLT: "#2C1512",
  onSecondaryFixedRedDT: "#2C1512",
  onSecondaryFixedOrangeLT: "#2B1609",
  onSecondaryFixedOrangeDT: "#2B1609",
  onSecondaryFixedYellowLT: "#241A04",
  onSecondaryFixedYellowDT: "#241A04",
  onSecondaryFixedChartreuseLT: "#1A1D07",
  onSecondaryFixedChartreuseDT: "#1A1D07",
  onSecondaryFixedGreenLT: "#0F1F11",
  onSecondaryFixedGreenDT: "#0F1F11",
  onSecondaryFixedTealLT: "#06201C",
  onSecondaryFixedTealDT: "#06201C",
  onSecondaryFixedCyanLT: "#061E25",
  onSecondaryFixedCyanDT: "#061E25",
  onSecondaryFixedBlueLT: "#151B2C",
  onSecondaryFixedBlueDT: "#151B2C",
  onSecondaryFixedIndigoLT: "#1A1A2C",
  onSecondaryFixedIndigoDT: "#1A1A2C",
  onSecondaryFixedPurpleLT: "#20182A",
  onSecondaryFixedPurpleDT: "#20182A",
  secondaryFixedDimLight: "#CCC2DC",
  secondaryFixedDimLightHighContrast: "#322359",
  secondaryFixedDimLightMediumContrast: "#62538C",
  secondaryFixedDimDark: "#CCC2DC",
  secondaryFixedDimDarkHighContrast: "#D3C1FF",
  secondaryFixedDimDarkMediumContrast: "#CFBDFE",
  secondaryFixedDimMonochromeLT: "#ABABAB",
  secondaryFixedDimMonochromeDT: "#ABABAB",
  secondaryFixedDimPinkLT: "#E1BDCA",
  secondaryFixedDimPinkDT: "#E1BDCA",
  secondaryFixedDimRoseLT: "#E5BDC1",
  secondaryFixedDimRoseDT: "#E5BDC1",
  secondaryFixedDimRedLT: "#E1B7B2",
  secondaryFixedDimRedDT: "#E1B7B2",
  secondaryFixedDimOrangeLT: "#DFB9A4",
  secondaryFixedDimOrangeDT: "#DFB9A4",
  secondaryFixedDimYellowLT: "#D8C4A1",
  secondaryFixedDimYellowDT: "#D8C4A1",
  secondaryFixedDimChartreuseLT: "#C7C9A6",
  secondaryFixedDimChartreuseDT: "#C7C9A6",
  secondaryFixedDimGreenLT: "#B8CCB6",
  secondaryFixedDimGreenDT: "#B8CCB6",
  secondaryFixedDimTealLT: "#B1CCC6",
  secondaryFixedDimTealDT: "#B1CCC6",
  secondaryFixedDimCyanLT: "#B2CBD3",
  secondaryFixedDimCyanDT: "#B2CBD3",
  secondaryFixedDimBlueLT: "#C0C6DC",
  secondaryFixedDimBlueDT: "#C0C6DC",
  secondaryFixedDimIndigoLT: "#C7C4DC",
  secondaryFixedDimIndigoDT: "#C7C4DC",
  secondaryFixedDimPurpleLT: "#CFC1DB",
  secondaryFixedDimPurpleDT: "#CFC1DB",
  onSecondaryFixedVariantLight: "#4A4458",
  onSecondaryFixedVariantLightHighContrast: "#FFFFFF",
  onSecondaryFixedVariantLightMediumContrast: "#FFFFFF",
  onSecondaryFixedVariantDark: "#4A4458",
  onSecondaryFixedVariantDarkHighContrast: "#1B0942",
  onSecondaryFixedVariantDarkMediumContrast: "#3C2D63",
  onSecondaryFixedVariantMonochromeLT: "#3B3B3C",
  onSecondaryFixedVariantMonochromeDT: "#3B3B3C",
  onSecondaryFixedVariantPinkLT: "#593F4B",
  onSecondaryFixedVariantPinkDT: "#593F4B",
  onSecondaryFixedVariantRoseLT: "#5C3F43",
  onSecondaryFixedVariantRoseDT: "#5C3F43",
  onSecondaryFixedVariantRedLT: "#5D3F3B",
  onSecondaryFixedVariantRedDT: "#5D3F3B",
  onSecondaryFixedVariantOrangeLT: "#5C4131",
  onSecondaryFixedVariantOrangeDT: "#5C4131",
  onSecondaryFixedVariantYellowLT: "#52452A",
  onSecondaryFixedVariantYellowDT: "#52452A",
  onSecondaryFixedVariantChartreuseLT: "#46492F",
  onSecondaryFixedVariantChartreuseDT: "#46492F",
  onSecondaryFixedVariantGreenLT: "#3A4B3A",
  onSecondaryFixedVariantGreenDT: "#3A4B3A",
  onSecondaryFixedVariantTealLT: "#334B47",
  onSecondaryFixedVariantTealDT: "#334B47",
  onSecondaryFixedVariantCyanLT: "#344A52",
  onSecondaryFixedVariantCyanDT: "#344A52",
  onSecondaryFixedVariantBlueLT: "#404659",
  onSecondaryFixedVariantBlueDT: "#404659",
  onSecondaryFixedVariantIndigoLT: "#454559",
  onSecondaryFixedVariantIndigoDT: "#454559",
  onSecondaryFixedVariantPurpleLT: "#4C4357",
  onSecondaryFixedVariantPurpleDT: "#4C4357",
  tertiaryFixedLight: "#FFD8E4",
  tertiaryFixedLightHighContrast: "#6B2F45",
  tertiaryFixedLightMediumContrast: "#A55F77",
  tertiaryFixedDark: "#FFD8E4",
  tertiaryFixedDarkHighContrast: "#FFDFE7",
  tertiaryFixedDarkMediumContrast: "#FFD9E3",
  tertiaryFixedMonochromeLT: "#5E5E5E",
  tertiaryFixedMonochromeDT: "#5E5E5E",
  tertiaryFixedPinkLT: "#FEC6A2",
  tertiaryFixedPinkDT: "#FEC6A2",
  tertiaryFixedRoseLT: "#FFD2A1",
  tertiaryFixedRoseDT: "#FFD2A1",
  tertiaryFixedRedLT: "#FADCA3",
  tertiaryFixedRedDT: "#FADCA3",
  tertiaryFixedOrangeLT: "#E6E2A9",
  tertiaryFixedOrangeDT: "#E6E2A9",
  tertiaryFixedYellowLT: "#C9E8C1",
  tertiaryFixedYellowDT: "#C9E8C1",
  tertiaryFixedChartreuseLT: "#BBE9DA",
  tertiaryFixedChartreuseDT: "#BBE9DA",
  tertiaryFixedGreenLT: "#BAE8F0",
  tertiaryFixedGreenDT: "#BAE8F0",
  tertiaryFixedTealLT: "#C5E3FF",
  tertiaryFixedTealDT: "#C5E3FF",
  tertiaryFixedCyanLT: "#D4D7FF",
  tertiaryFixedCyanDT: "#D4D7FF",
  tertiaryFixedBlueLT: "#FBD4F7",
  tertiaryFixedBlueDT: "#FBD4F7",
  tertiaryFixedIndigoLT: "#FFCCE5",
  tertiaryFixedIndigoDT: "#FFCCE5",
  tertiaryFixedPurpleLT: "#FDC2CD",
  tertiaryFixedPurpleDT: "#FDC2CD",
  onTertiaryFixedLight: "#31111D",
  onTertiaryFixedLightHighContrast: "#FFFFFF",
  onTertiaryFixedLightMediumContrast: "#FFFFFF",
  onTertiaryFixedDark: "#31111D",
  onTertiaryFixedDarkHighContrast: "#000000",
  onTertiaryFixedDarkMediumContrast: "#2B0013",
  onTertiaryFixedMonochromeLT: "#FFFFFF",
  onTertiaryFixedMonochromeDT: "#FFFFFF",
  onTertiaryFixedPinkLT: "#301401",
  onTertiaryFixedPinkDT: "#301401",
  onTertiaryFixedRoseLT: "#2B1700",
  onTertiaryFixedRoseDT: "#2B1700",
  onTertiaryFixedRedLT: "#261A00",
  onTertiaryFixedRedDT: "#261A00",
  onTertiaryFixedOrangeLT: "#1D1D00",
  onTertiaryFixedOrangeDT: "#1D1D00",
  onTertiaryFixedYellowLT: "#082008",
  onTertiaryFixedYellowDT: "#082008",
  onTertiaryFixedChartreuseLT: "#002019",
  onTertiaryFixedChartreuseDT: "#002019",
  onTertiaryFixedGreenLT: "#001F24",
  onTertiaryFixedGreenDT: "#001F24",
  onTertiaryFixedTealLT: "#001E30",
  onTertiaryFixedTealDT: "#001E30",
  onTertiaryFixedCyanLT: "#151937",
  onTertiaryFixedCyanDT: "#151937",
  onTertiaryFixedBlueLT: "#2A122C",
  onTertiaryFixedBlueDT: "#2A122C",
  onTertiaryFixedIndigoLT: "#2F1123",
  onTertiaryFixedIndigoDT: "#2F1123",
  onTertiaryFixedPurpleLT: "#321019",
  onTertiaryFixedPurpleDT: "#321019",
  tertiaryFixedDimLight: "#EFB8C8",
  tertiaryFixedDimLightHighContrast: "#50192F",
  tertiaryFixedDimLightMediumContrast: "#89475E",
  tertiaryFixedDimDark: "#EFB8C8",
  tertiaryFixedDimDarkHighContrast: "#FFB7CD",
  tertiaryFixedDimDarkMediumContrast: "#FFB0C9",
  tertiaryFixedDimMonochromeLT: "#474747",
  tertiaryFixedDimMonochromeDT: "#474747",
  tertiaryFixedDimPinkLT: "#E0AB88",
  tertiaryFixedDimPinkDT: "#E0AB88",
  tertiaryFixedDimRoseLT: "#E1B788",
  tertiaryFixedDimRoseDT: "#E1B788",
  tertiaryFixedDimRedLT: "#DFC38C",
  tertiaryFixedDimRedDT: "#DFC38C",
  tertiaryFixedDimOrangeLT: "#CCC992",
  tertiaryFixedDimOrangeDT: "#CCC992",
  tertiaryFixedDimYellowLT: "#B0CFA9",
  tertiaryFixedDimYellowDT: "#B0CFA9",
  tertiaryFixedDimChartreuseLT: "#A3D0C1",
  tertiaryFixedDimChartreuseDT: "#A3D0C1",
  tertiaryFixedDimGreenLT: "#A1CED6",
  tertiaryFixedDimGreenDT: "#A1CED6",
  tertiaryFixedDimTealLT: "#ACCAE5",
  tertiaryFixedDimTealDT: "#ACCAE5",
  tertiaryFixedDimCyanLT: "#B8BCE2",
  tertiaryFixedDimCyanDT: "#B8BCE2",
  tertiaryFixedDimBlueLT: "#E0BBDD",
  tertiaryFixedDimBlueDT: "#E0BBDD",
  tertiaryFixedDimIndigoLT: "#E1B1C9",
  tertiaryFixedDimIndigoDT: "#E1B1C9",
  tertiaryFixedDimPurpleLT: "#DFA7B2",
  tertiaryFixedDimPurpleDT: "#DFA7B2",
  onTertiaryFixedVariantLight: "#633B48",
  onTertiaryFixedVariantLightHighContrast: "#FFFFFF",
  onTertiaryFixedVariantLightMediumContrast: "#FFFFFF",
  onTertiaryFixedVariantDark: "#633B48",
  onTertiaryFixedVariantDarkHighContrast: "#330218",
  onTertiaryFixedVariantDarkMediumContrast: "#5B2238",
  onTertiaryFixedVariantMonochromeLT: "#E3E2E2",
  onTertiaryFixedVariantMonochromeDT: "#E3E2E2",
  onTertiaryFixedVariantPinkLT: "#633E24",
  onTertiaryFixedVariantPinkDT: "#633E24",
  onTertiaryFixedVariantRoseLT: "#5C4122",
  onTertiaryFixedVariantRoseDT: "#5C4122",
  onTertiaryFixedVariantRedLT: "#544522",
  onTertiaryFixedVariantRedDT: "#544522",
  onTertiaryFixedVariantOrangeLT: "#494923",
  onTertiaryFixedVariantOrangeDT: "#494923",
  onTertiaryFixedVariantYellowLT: "#344D30",
  onTertiaryFixedVariantYellowDT: "#344D30",
  onTertiaryFixedVariantChartreuseLT: "#2E4D44",
  onTertiaryFixedVariantChartreuseDT: "#2E4D44",
  onTertiaryFixedVariantGreenLT: "#2F4B51",
  onTertiaryFixedVariantGreenDT: "#2F4B51",
  onTertiaryFixedVariantTealLT: "#30495D",
  onTertiaryFixedVariantTealDT: "#30495D",
  onTertiaryFixedVariantCyanLT: "#414465",
  onTertiaryFixedVariantCyanDT: "#414465",
  onTertiaryFixedVariantBlueLT: "#593D5A",
  onTertiaryFixedVariantBlueDT: "#593D5A",
  onTertiaryFixedVariantIndigoLT: "#603C4F",
  onTertiaryFixedVariantIndigoDT: "#603C4F",
  onTertiaryFixedVariantPurpleLT: "#653A44",
  onTertiaryFixedVariantPurpleDT: "#653A44",
  surfaceDimLight: "#DED8E1",
  surfaceDimLightHighContrast: "#DED8E0",
  surfaceDimLightMediumContrast: "#DED8E0",
  surfaceDimDark: "#141218",
  surfaceDimDarkHighContrast: "#141218",
  surfaceDimDarkMediumContrast: "#141218",
  surfaceDimMonochromeLT: "#DADADA",
  surfaceDimMonochromeDT: "#131313",
  surfaceDimPinkLT: "#E5D6DA",
  surfaceDimPinkDT: "#191114",
  surfaceDimRoseLT: "#E7D6D7",
  surfaceDimRoseDT: "#191112",
  surfaceDimRedLT: "#E8D6D4",
  surfaceDimRedDT: "#1A1110",
  surfaceDimOrangeLT: "#E7D7CF",
  surfaceDimOrangeDT: "#1A120D",
  surfaceDimYellowLT: "#E2D9CC",
  surfaceDimYellowDT: "#17130B",
  surfaceDimChartreuseLT: "#DCDACE",
  surfaceDimChartreuseDT: "#13140D",
  surfaceDimGreenLT: "#D7DBD3",
  surfaceDimGreenDT: "#101510",
  surfaceDimTealLT: "#D5DBD9",
  surfaceDimTealDT: "#0E1513",
  surfaceDimCyanLT: "#D6DBDD",
  surfaceDimCyanDT: "#0F1416",
  surfaceDimBlueLT: "#DAD9E0",
  surfaceDimBlueDT: "#121318",
  surfaceDimIndigoLT: "#DCD8E0",
  surfaceDimIndigoDT: "#131318",
  surfaceDimPurpleLT: "#DFD8E0",
  surfaceDimPurpleDT: "#151218",
  surfaceBrightLight: "#FEF7FF",
  surfaceBrightLightHighContrast: "#FDF7FF",
  surfaceBrightLightMediumContrast: "#FDF7FF",
  surfaceBrightDark: "#3B383E",
  surfaceBrightDarkHighContrast: "#3B383E",
  surfaceBrightDarkMediumContrast: "#3B383E",
  surfaceBrightMonochromeLT: "#F9F9F9",
  surfaceBrightMonochromeDT: "#393939",
  surfaceBrightPinkLT: "#FFF8F8",
  surfaceBrightPinkDT: "#40373A",
  surfaceBrightRoseLT: "#FFF8F7",
  surfaceBrightRoseDT: "#413738",
  surfaceBrightRedLT: "#FFF8F7",
  surfaceBrightRedDT: "#423735",
  surfaceBrightOrangeLT: "#FFF8F5",
  surfaceBrightOrangeDT: "#413732",
  surfaceBrightYellowLT: "#FFF8F2",
  surfaceBrightYellowDT: "#3E382F",
  surfaceBrightChartreuseLT: "#FCFAED",
  surfaceBrightChartreuseDT: "#393A31",
  surfaceBrightGreenLT: "#F7FBF2",
  surfaceBrightGreenDT: "#363A35",
  surfaceBrightTealLT: "#F4FBF8",
  surfaceBrightTealDT: "#343B39",
  surfaceBrightCyanLT: "#F5FAFD",
  surfaceBrightCyanDT: "#343A3C",
  surfaceBrightBlueLT: "#FAF8FF",
  surfaceBrightBlueDT: "#38393F",
  surfaceBrightIndigoLT: "#FCF8FF",
  surfaceBrightIndigoDT: "#39383F",
  surfaceBrightPurpleLT: "#FEF7FF",
  surfaceBrightPurpleDT: "#3B383E",
  surfaceContainerLowestLight: "#FFFFFF",
  surfaceContainerLowestLightHighContrast: "#FFFFFF",
  surfaceContainerLowestLightMediumContrast: "#FFFFFF",
  surfaceContainerLowestDark: "#0F0D13",
  surfaceContainerLowestDarkHighContrast: "#0F0D13",
  surfaceContainerLowestDarkMediumContrast: "#0F0D13",
  surfaceContainerLowestMonochromeLT: "#FFFFFF",
  surfaceContainerLowestMonochromeDT: "#0E0E0E",
  surfaceContainerLowestPinkLT: "#FFFFFF",
  surfaceContainerLowestPinkDT: "#130C0F",
  surfaceContainerLowestRoseLT: "#FFFFFF",
  surfaceContainerLowestRoseDT: "#140C0D",
  surfaceContainerLowestRedLT: "#FFFFFF",
  surfaceContainerLowestRedDT: "#140C0B",
  surfaceContainerLowestOrangeLT: "#FFFFFF",
  surfaceContainerLowestOrangeDT: "#140D08",
  surfaceContainerLowestYellowLT: "#FFFFFF",
  surfaceContainerLowestYellowDT: "#110E07",
  surfaceContainerLowestChartreuseLT: "#FFFFFF",
  surfaceContainerLowestChartreuseDT: "#0E0F08",
  surfaceContainerLowestGreenLT: "#FFFFFF",
  surfaceContainerLowestGreenDT: "#0B0F0B",
  surfaceContainerLowestTealLT: "#FFFFFF",
  surfaceContainerLowestTealDT: "#090F0E",
  surfaceContainerLowestCyanLT: "#FFFFFF",
  surfaceContainerLowestCyanDT: "#090F11",
  surfaceContainerLowestBlueLT: "#FFFFFF",
  surfaceContainerLowestBlueDT: "#0C0E13",
  surfaceContainerLowestIndigoLT: "#FFFFFF",
  surfaceContainerLowestIndigoDT: "#0E0E13",
  surfaceContainerLowestPurpleLT: "#FFFFFF",
  surfaceContainerLowestPurpleDT: "#100D12",
  surfaceContainerLowLight: "#F7F2FA",
  surfaceContainerLowLightHighContrast: "#F8F2FA",
  surfaceContainerLowLightMediumContrast: "#F8F2FA",
  surfaceContainerLowDark: "#1D1B20",
  surfaceContainerLowDarkHighContrast: "#1D1B20",
  surfaceContainerLowDarkMediumContrast: "#1D1B20",
  surfaceContainerLowMonochromeLT: "#F3F3F3",
  surfaceContainerLowMonochromeDT: "#1B1B1B",
  surfaceContainerLowPinkLT: "#FFF0F4",
  surfaceContainerLowPinkDT: "#21191C",
  surfaceContainerLowRoseLT: "#FFF0F1",
  surfaceContainerLowRoseDT: "#22191A",
  surfaceContainerLowRedLT: "#FFF0EE",
  surfaceContainerLowRedDT: "#231918",
  surfaceContainerLowOrangeLT: "#FFF1EB",
  surfaceContainerLowOrangeDT: "#221A15",
  surfaceContainerLowYellowLT: "#FCF2E5",
  surfaceContainerLowYellowDT: "#1F1B13",
  surfaceContainerLowChartreuseLT: "#F6F4E7",
  surfaceContainerLowChartreuseDT: "#1B1C14",
  surfaceContainerLowGreenLT: "#F1F5EC",
  surfaceContainerLowGreenDT: "#181D18",
  surfaceContainerLowTealLT: "#EFF5F2",
  surfaceContainerLowTealDT: "#171D1B",
  surfaceContainerLowCyanLT: "#EFF4F7",
  surfaceContainerLowCyanDT: "#171C1E",
  surfaceContainerLowBlueLT: "#F4F3FA",
  surfaceContainerLowBlueDT: "#1A1B21",
  surfaceContainerLowIndigoLT: "#F6F2FA",
  surfaceContainerLowIndigoDT: "#1C1B21",
  surfaceContainerLowPurpleLT: "#F9F1F9",
  surfaceContainerLowPurpleDT: "#1D1A20",
  surfaceContainerLight: "#F3EDF7",
  surfaceContainerLightHighContrast: "#F2ECF4",
  surfaceContainerLightMediumContrast: "#F2ECF4",
  surfaceContainerDark: "#211F26",
  surfaceContainerDarkHighContrast: "#211F24",
  surfaceContainerDarkMediumContrast: "#211F24",
  surfaceContainerMonochromeLT: "#EEEEEE",
  surfaceContainerMonochromeDT: "#1F1F1F",
  surfaceContainerPinkLT: "#FAEAEE",
  surfaceContainerPinkDT: "#251D20",
  surfaceContainerRoseLT: "#FBEAEB",
  surfaceContainerRoseDT: "#261D1E",
  surfaceContainerRedLT: "#FCEAE7",
  surfaceContainerRedDT: "#271D1C",
  surfaceContainerOrangeLT: "#FCEAE2",
  surfaceContainerOrangeDT: "#271E19",
  surfaceContainerYellowLT: "#F7ECDF",
  surfaceContainerYellowDT: "#241F17",
  surfaceContainerChartreuseLT: "#F0EEE1",
  surfaceContainerChartreuseDT: "#202018",
  surfaceContainerGreenLT: "#EBEFE7",
  surfaceContainerGreenDT: "#1C211C",
  surfaceContainerTealLT: "#E9EFEC",
  surfaceContainerTealDT: "#1A211F",
  surfaceContainerCyanLT: "#EAEFF1",
  surfaceContainerCyanDT: "#1B2022",
  surfaceContainerBlueLT: "#EEEDF4",
  surfaceContainerBlueDT: "#1E1F25",
  surfaceContainerIndigoLT: "#F0ECF4",
  surfaceContainerIndigoDT: "#201F25",
  surfaceContainerPurpleLT: "#F3ECF4",
  surfaceContainerPurpleDT: "#211E24",
  surfaceContainerHighLight: "#ECE6F0",
  surfaceContainerHighLightHighContrast: "#ECE6EE",
  surfaceContainerHighLightMediumContrast: "#ECE6EE",
  surfaceContainerHighDark: "#2B2930",
  surfaceContainerHighDarkHighContrast: "#2B292F",
  surfaceContainerHighDarkMediumContrast: "#2B292F",
  surfaceContainerHighMonochromeLT: "#E8E8E8",
  surfaceContainerHighMonochromeDT: "#2A2A2A",
  surfaceContainerHighPinkLT: "#F4E4E8",
  surfaceContainerHighPinkDT: "#30282B",
  surfaceContainerHighRoseLT: "#F6E4E5",
  surfaceContainerHighRoseDT: "#312829",
  surfaceContainerHighRedLT: "#F7E4E2",
  surfaceContainerHighRedDT: "#322826",
  surfaceContainerHighOrangeLT: "#F6E5DD",
  surfaceContainerHighOrangeDT: "#312823",
  surfaceContainerHighYellowLT: "#F1E7D9",
  surfaceContainerHighYellowDT: "#2E2921",
  surfaceContainerHighChartreuseLT: "#EAE9DC",
  surfaceContainerHighChartreuseDT: "#2A2B22",
  surfaceContainerHighGreenLT: "#E5E9E1",
  surfaceContainerHighGreenDT: "#272B26",
  surfaceContainerHighTealLT: "#E3EAE7",
  surfaceContainerHighTealDT: "#252B2A",
  surfaceContainerHighCyanLT: "#E4E9EB",
  surfaceContainerHighCyanDT: "#252B2D",
  surfaceContainerHighBlueLT: "#E8E7EF",
  surfaceContainerHighBlueDT: "#282A2F",
  surfaceContainerHighIndigoLT: "#EAE7EF",
  surfaceContainerHighIndigoDT: "#2A292F",
  surfaceContainerHighPurpleLT: "#EDE6EE",
  surfaceContainerHighPurpleDT: "#2C292F",
  surfaceContainerHighestLight: "#E6E0E9",
  surfaceContainerHighestLightHighContrast: "#E6E0E9",
  surfaceContainerHighestLightMediumContrast: "#E6E0E9",
  surfaceContainerHighestDark: "#36343B",
  surfaceContainerHighestDarkHighContrast: "#36343A",
  surfaceContainerHighestDarkMediumContrast: "#36343A",
  surfaceContainerHighestMonochromeLT: "#E2E2E2",
  surfaceContainerHighestMonochromeDT: "#353535",
  surfaceContainerHighestPinkLT: "#EEDFE3",
  surfaceContainerHighestPinkDT: "#3B3235",
  surfaceContainerHighestRoseLT: "#F0DEDF",
  surfaceContainerHighestRoseDT: "#3D3233",
  surfaceContainerHighestRedLT: "#F1DEDC",
  surfaceContainerHighestRedDT: "#3D3231",
  surfaceContainerHighestOrangeLT: "#F0DFD7",
  surfaceContainerHighestOrangeDT: "#3D332D",
  surfaceContainerHighestYellowLT: "#EBE1D4",
  surfaceContainerHighestYellowDT: "#39342B",
  surfaceContainerHighestChartreuseLT: "#E5E3D6",
  surfaceContainerHighestChartreuseDT: "#35352D",
  surfaceContainerHighestGreenLT: "#E0E4DB",
  surfaceContainerHighestGreenDT: "#313630",
  surfaceContainerHighestTealLT: "#DDE4E1",
  surfaceContainerHighestTealDT: "#303634",
  surfaceContainerHighestCyanLT: "#DEE3E6",
  surfaceContainerHighestCyanDT: "#303638",
  surfaceContainerHighestBlueLT: "#E2E2E9",
  surfaceContainerHighestBlueDT: "#33343A",
  surfaceContainerHighestIndigoLT: "#E5E1E9",
  surfaceContainerHighestIndigoDT: "#35343A",
  surfaceContainerHighestPurpleLT: "#E7E0E8",
  surfaceContainerHighestPurpleDT: "#37333A",
  opacity08Light: "#E6E0E9",
  opacity08LightHighContrast: "#E6E0E9",
  opacity08LightMediumContrast: "#E6E0E9",
  opacity08Dark: "#36343B",
  opacity08DarkHighContrast: "#36343A",
  opacity08DarkMediumContrast: "#36343A",
  opacity08MonochromeLT: "#E2E2E2",
  opacity08MonochromeDT: "#353535",
  opacity08PinkLT: "#EEDFE3",
  opacity08PinkDT: "#3B3235",
  opacity08RoseLT: "#F0DEDF",
  opacity08RoseDT: "#3D3233",
  opacity08RedLT: "#F1DEDC",
  opacity08RedDT: "#3D3231",
  opacity08OrangeLT: "#F0DFD7",
  opacity08OrangeDT: "#3D332D",
  opacity08YellowLT: "#EBE1D4",
  opacity08YellowDT: "#39342B",
  opacity08ChartreuseLT: "#E5E3D6",
  opacity08ChartreuseDT: "#35352D",
  opacity08GreenLT: "#E0E4DB",
  opacity08GreenDT: "#313630",
  opacity08TealLT: "#DDE4E1",
  opacity08TealDT: "#303634",
  opacity08CyanLT: "#DEE3E6",
  opacity08CyanDT: "#303638",
  opacity08BlueLT: "#E2E2E9",
  opacity08BlueDT: "#33343A",
  opacity08IndigoLT: "#E5E1E9",
  opacity08IndigoDT: "#35343A",
  opacity08PurpleLT: "#E7E0E8",
  opacity08PurpleDT: "#37333A",
  opacity12Light: "#E6E0E9",
  opacity12LightHighContrast: "#E6E0E9",
  opacity12LightMediumContrast: "#E6E0E9",
  opacity12Dark: "#36343B",
  opacity12DarkHighContrast: "#36343A",
  opacity12DarkMediumContrast: "#36343A",
  opacity12MonochromeLT: "#E2E2E2",
  opacity12MonochromeDT: "#353535",
  opacity12PinkLT: "#EEDFE3",
  opacity12PinkDT: "#3B3235",
  opacity12RoseLT: "#F0DEDF",
  opacity12RoseDT: "#3D3233",
  opacity12RedLT: "#F1DEDC",
  opacity12RedDT: "#3D3231",
  opacity12OrangeLT: "#F0DFD7",
  opacity12OrangeDT: "#3D332D",
  opacity12YellowLT: "#EBE1D4",
  opacity12YellowDT: "#39342B",
  opacity12ChartreuseLT: "#E5E3D6",
  opacity12ChartreuseDT: "#35352D",
  opacity12GreenLT: "#E0E4DB",
  opacity12GreenDT: "#313630",
  opacity12TealLT: "#DDE4E1",
  opacity12TealDT: "#303634",
  opacity12CyanLT: "#DEE3E6",
  opacity12CyanDT: "#303638",
  opacity12BlueLT: "#E2E2E9",
  opacity12BlueDT: "#33343A",
  opacity12IndigoLT: "#E5E1E9",
  opacity12IndigoDT: "#35343A",
  opacity12PurpleLT: "#E7E0E8",
  opacity12PurpleDT: "#37333A",
  opacity16Light: "#E6E0E9",
  opacity16LightHighContrast: "#E6E0E9",
  opacity16LightMediumContrast: "#E6E0E9",
  opacity16Dark: "#36343B",
  opacity16DarkHighContrast: "#36343A",
  opacity16DarkMediumContrast: "#36343A",
  opacity16MonochromeLT: "#E2E2E2",
  opacity16MonochromeDT: "#353535",
  opacity16PinkLT: "#EEDFE3",
  opacity16PinkDT: "#3B3235",
  opacity16RoseLT: "#F0DEDF",
  opacity16RoseDT: "#3D3233",
  opacity16RedLT: "#F1DEDC",
  opacity16RedDT: "#3D3231",
  opacity16OrangeLT: "#F0DFD7",
  opacity16OrangeDT: "#3D332D",
  opacity16YellowLT: "#EBE1D4",
  opacity16YellowDT: "#39342B",
  opacity16ChartreuseLT: "#E5E3D6",
  opacity16ChartreuseDT: "#35352D",
  opacity16GreenLT: "#E0E4DB",
  opacity16GreenDT: "#313630",
  opacity16TealLT: "#DDE4E1",
  opacity16TealDT: "#303634",
  opacity16CyanLT: "#DEE3E6",
  opacity16CyanDT: "#303638",
  opacity16BlueLT: "#E2E2E9",
  opacity16BlueDT: "#33343A",
  opacity16IndigoLT: "#E5E1E9",
  opacity16IndigoDT: "#35343A",
  opacity16PurpleLT: "#E7E0E8",
  opacity16PurpleDT: "#37333A",
};

export const COLORS_TO_BE_REVIEWED = {
  black: "#000000",
  white: "#FFFFFF",

  blueBackgraound: "#E0F9FF",
  blueBorder: "#62CFEB",
  blueBorder2: "#00ACC1",
  blueBorder3: "#91BADA",
  greenBlueProgressBar: "#04ABC1",
  lightBlue: "#A7EDFF",

  lightGreyBackground: "#F2F3F5",
  lightGreyIcon: "#9E9E9E",
  darkGreyIcon: "#1F1F1F",
  darkGrey: "#1E1E1E",
  anotherDarkGrey: "#605E5E",
  anotherLightGray: "#ADAAAA",
  anotherLightGray2: "#C3BEBE",
  textGrey: "#AAA",
  neutral15: "#262526",
  neutral35: "#545252",
  neutral50: "#797676",
  neutral60: "#939090",
  neutral70: "#ADAAAA",
  neutral80: "#C9C6C5",
  neutral90: "#E5E1E1",
  neutral95: "#F4F0EF",
  unknownBorder: "#DCDCDC",
  greyBackground: "#F3F4F6",
  greyBorder: "#D9D9D9",
  greyBorder2: "#F7F7F7",
  greyBorder3: "#ECECEC",
  lightGrayBackground: "#F2F3F5",
  skeletonGray: "#F4F0EF",
  skeletonDarkerGray: "#E5E1E1",
  formElementBackground: "#F9F6F6",

  errorContainer: "#FFDAD6",

  greenIcon: "#2CA640",
  // confirmation green, e.g. a value that was just copied
  success: "#178038",
  // M3 ref primary95, the lightest primary tint
  primary95: "#F6EDFF",
  error: "#D32F2F",

  lavender: "#B69DF7",

  lightGreyText: "#5F6367",

  buttonOutlinedBorderGray: "#9AA0A6",
  dividerColor: "#DADBDC",
  tableRowHover: "#F1F3F4",
};
